/**
 * Human-readable size and date formatting, `Intl`-based (task requirement:
 * "human-readable sizes and dates (Intl)"). English only, matching the
 * portal's English-only UI language (ADR 0008 section 1).
 */

const BYTE_UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

const sizeFormatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 });

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < BYTE_UNITS.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  return `${sizeFormatter.format(value)} ${BYTE_UNITS[unitIndex]}`;
}

const dateTimeFormatter = new Intl.DateTimeFormat("en-US", {
  dateStyle: "medium",
  timeStyle: "short",
});

/** Formats a FileInfo.lastModified (ISO 8601 date-time) for display. */
export function formatDateTime(iso: string): string {
  return dateTimeFormatter.format(new Date(iso));
}
